import { NavigateFunction } from 'react-router';

export const navigateToReport = (
    navigate: NavigateFunction,
    orderId: number,
    reportId: number | undefined,
    reportController: string,
    orderProcedureIds?: number[],
    bulk?: boolean,
    bulkType?: number,
): void => {
    switch (reportController) {
        case 'Procedure Combination': {
            const params = new URLSearchParams();

            if (reportId !== undefined) {
                params.append('Report_UID', `${reportId}`);
            }

            if (orderProcedureIds && orderProcedureIds.length > 0) {
                params.append('Procedure_IDs', orderProcedureIds.join('_'));
            }

            if (bulk !== undefined) {
                params.append('Bulk', bulk.toString());
            }

            if (bulk !== undefined && bulkType !== undefined) {
                params.append('Type', bulkType.toString());
            }

            navigate(`/Reports/ProcedureCombinationPartialReport/${orderId}?${params}`)
                .catch((err) => {
                    console.error(`Failed to navigate to procedure combination report. OrderID ${orderId} | ReportID ${reportId} | OrderProcedureIds`, orderProcedureIds, err);
                });
            break;
        }
        case 'Order':
            navigate(`/Reports/OrderDetail/${orderId}`)
                .catch((err) => {
                    console.error(`Failed to navigate to order report. OrderID ${orderId} | ReportID ${reportId}`, err);
                });
            break;
        default:
            console.warn(`Unknown report controller: ${reportController}`);
            break;
    }
};
